export const VIEW_BY_OPTIONS = {
  NAME: "Name",
  COUNTRY: "Country",
  REVENUE: "Revenue",
  COMPANY_TYPE: "Company Type",
} as const;

export const REVENUE_BANDS = [
  { value: 5e9, label: "$5.0bn and above" },
  { value: 1e9, label: "$1.0bn to $5.0bn" },
  { value: 500e6, label: "$500.0m to $1.0bn" },
  { value: 250e6, label: "$250.0m to $500.0m" },
  { value: 50e6, label: "$50.0m to $250.0m" },
  { value: 25e6, label: "$25.0m to $50.0m" },
  { value: 10e6, label: "$10.0m to $25.0m" },
  { value: 0, label: "Less than $10.0m" },
];

export const COMPANY_TYPES = [
  { value: "isGhq", label: "Global Headquarters (GHQ)" },
  { value: "isGp", label: "Corporate Parent" },
  { value: "isDp", label: "Domestic Parent" },
];

export type CompanyTypeKey = "isGhq" | "isGp" | "isDp";

// O(1) revenue band lookup function
export const getRevenueBand = (revenueMin: number): string => {
  if (revenueMin === -1) return "Unknown";
  if (revenueMin >= 5e9) return "$5.0bn and above";
  if (revenueMin >= 1e9) return "$1.0bn to $5.0bn";
  if (revenueMin >= 500e6) return "$500.0m to $1.0bn";
  if (revenueMin >= 250e6) return "$250.0m to $500.0m";
  if (revenueMin >= 50e6) return "$50.0m to $250.0m";
  if (revenueMin >= 25e6) return "$25.0m to $50.0m";
  if (revenueMin >= 10e6) return "$10.0m to $25.0m";
  return "Less than $10.0m";
};

// Company tooltip constants
export const TOOLTIP_ICON_STYLE = {
  fontSize: 14,
  color: "text.secondary",
} as const;
